module.exports = __webpack_public_path__ + "static/numer-konta-26-cyfr-4fa9e9e63042d6c688bdb6b5f41b6a84.jpg";